import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useTranslation } from 'react-i18next';

import { WIDGET_BY_ID } from './registry';
import { SIZES } from './sizes';

/** Mobile edit mode: a reorder list with arrows and remove (no drag, sizes not editable). */
export default function MobileWidgetList({ widgets, actions, onAddWidget }) {
  const { t } = useTranslation();
  return (
    <Box data-testid="mobile-edit-list" sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {widgets.map((widget, index) => {
        const entry = WIDGET_BY_ID[widget.id];
        if (!entry) return null;
        const Icon = entry.icon;
        return (
          <Box key={widget.id} data-testid={`mobile-edit-row-${widget.id}`} sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1, pl: 1.5, bgcolor: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px' }}>
            <Icon sx={{ fontSize: 20, color: '#64748b' }} />
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography noWrap sx={{ fontSize: 14, fontWeight: 600 }}>
                {t(`dashboard.widgets.${widget.id}.title`)}
              </Typography>
              <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>{t(SIZES[widget.size]?.labelKey || SIZES.M.labelKey)}</Typography>
            </Box>
            <IconButton size="small" data-testid={`mobile-move-up-${widget.id}`} disabled={index === 0} onClick={() => actions.moveBy(widget.id, -1)} sx={{ width: 36, height: 36 }}>
              <KeyboardArrowUpIcon />
            </IconButton>
            <IconButton size="small" data-testid={`mobile-move-down-${widget.id}`} disabled={index === widgets.length - 1} onClick={() => actions.moveBy(widget.id, 1)} sx={{ width: 36, height: 36 }}>
              <KeyboardArrowDownIcon />
            </IconButton>
            <IconButton size="small" data-testid={`mobile-remove-${widget.id}`} onClick={() => actions.remove(widget.id)} sx={{ width: 36, height: 36, '&:hover': { color: '#c53030' } }}>
              <CloseIcon />
            </IconButton>
          </Box>
        );
      })}
      <Box
        component="button"
        type="button"
        data-testid="mobile-add-widget"
        onClick={onAddWidget}
        sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, height: 52, border: '1.5px dashed #cbd5e1', borderRadius: '12px', bgcolor: 'transparent', color: '#64748b', fontSize: 14, fontWeight: 500, fontFamily: 'inherit', cursor: 'pointer' }}
      >
        <AddIcon sx={{ fontSize: 20 }} />
        {t('dashboard.edit.addWidget')}
      </Box>
    </Box>
  );
}
